import { extends as _extends, objectDestructuringEmpty as _objectDestructuringEmpty, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import React__default, { useMemo } from 'react';
import { sizes } from './bullet.sizes.esm.js';
import Text from '../text/text.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';

var _excluded = ["size", "className"];
function PrivateBullet(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useComponentTheme('Text');
  var classes = useMemo(function () {
    return theme({
      className: className
    });
  }, [theme, className]);
  var classNames = useMemo(function () {
    return cn("csg-tw-text flex w-1 items-center ".concat(classes));
  }, [classes]);
  return /*#__PURE__*/React__default.createElement(Text, _extends({
    role: "bullet",
    variant: sizes[size],
    className: classNames
  }, rest), "\u2022");
}
function Bullet(props) {
  var rest = _extends({}, (_objectDestructuringEmpty(props), props));
  return /*#__PURE__*/React__default.createElement(PrivateBullet, rest);
}
Bullet.displayName = 'Bullet';

export { Bullet as default };
//# sourceMappingURL=bullet.esm.js.map
